import AttendanceCreateComponent from "../components/AttendanceCreate";
import useAttendance from "../hooks/useAttendance";

const AttendanceCreate = () => {
  const AttendanceProps = useAttendance();
  return <AttendanceCreateComponent {...AttendanceProps} />;
};

export default AttendanceCreate;
